import {PublicClientApplication} from '@azure/msal-browser';
import {STATIC_CONFIGS} from '../../configs/static.config';

export function msalInstanceFactory(): PublicClientApplication {
    return new PublicClientApplication({
        auth: {
            clientId: STATIC_CONFIGS.msal.clientId,
            authority: STATIC_CONFIGS.msal.authority,
            redirectUri: STATIC_CONFIGS.msal.redirectUri,
            postLogoutRedirectUri: STATIC_CONFIGS.msal.postLogoutRedirectUri,
            navigateToLoginRequestUrl: false,
        },
        cache: {
            cacheLocation: STATIC_CONFIGS.msal.browserCacheLocation,
        }
    });
}
